import { Text } from "@ds/react";
import styled from "styled-components/macro";

export const HomeContentContainer = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  alignItems: "flex-start",
  h3: {
    fontSize: "18px",
    fontWeight: "500",
    color: theme.color.neutral["02"],
    lineHeight: "28.8px",
    margin: "0",
  },
  [theme.breakpoint.lg()]: {
    gap: "40px",
  },
}));

export const ContentSectionContainer = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
}));

export const StyledTitle = styled(Text)(({ theme }) => ({
  fontSize: "18px",
  fontWeight: "500",
  color: theme.color.neutral["02"],
  lineHeight: "28.8px",

  "&.noBold": {
    fontWeight: 400,
  },

  [theme.breakpoint.lg()]: {
    fontSize: "20px",
    lineHeight: "32px",
  },
}));

export const PrizeContainer = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  p: {
    color: theme.color.brandPrimary.medium,
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "24px",
    paddingLeft: "18px",
    paddingBottom: "12px",
    borderLeft: `2px solid ${theme.color.brandSecondary.light}`,
    margin: "0",
  },
  "p:last-child": {
    paddingBottom: "0px",
  },
  [theme.breakpoint.lg()]: {
    p: {
      fontSize: "18px",
      lineHeight: "27px",
    },
  },
}));

export const PrizeText = styled(Text)(({ theme }) => ({
  color: theme.color.brandPrimary.medium,
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "24px",
  paddingLeft: "18px",
  borderLeft: `2px solid ${theme.color.line.medium}`,
  [theme.breakpoint.lg()]: {
    fontSize: "18px",
    lineHeight: "27px",
  },
}));
